import { render } from "./SlaveApp.vue?vue&type=template&id=676acfde&lang=pug"
import script from "./SlaveApp.vue?vue&type=script&lang=js"
export * from "./SlaveApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__